import VocWaves from "./src/main"

/* istanbul ignore next */
VocWaves.install = function (Vue) {
  Vue.component(VocWaves.name, VocWaves)
}

export default VocWaves
